import Dashboard from './index';

export default Dashboard;
